// extracted by mini-css-extract-plugin
export default {"layout404":"Layout404_layout404__HzKM5","active":"Layout404_active__c5GZg"};